import React from 'react';
import { Link } from 'react-router-dom';
import ToolLogo from './ToolLogo';

const getDomainFromUrl = (rawUrl = '') => {
  const trimmed = String(rawUrl || '').trim();
  if (!trimmed) return '';

  try {
    return new URL(trimmed).hostname;
  } catch {
    return trimmed.replace(/^https?:\/\//i, '').split('/')[0];
  }
};

const EnterpriseBentoGrid = ({ tools = [] }) => {
  if (!tools.length) return null;

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-testid="enterprise-bento-grid">
      {tools.map((tool) => {
        const isFeatured = Boolean(tool.featured || tool.is_featured || String(tool.status || '').toLowerCase() === 'featured');
        const domain = getDomainFromUrl(tool.website_url || tool.direct_url || tool.affiliate_url || '');

        return (
          <article
            key={tool.id || tool.slug || tool.name}
            className={`enterprise-tool-card group rounded-2xl border p-5 flex flex-col gap-4 transition-all duration-300 ${
              isFeatured
                ? 'md:col-span-2 enterprise-tool-card--featured'
                : 'md:col-span-1'
            }`}
          >
            <div className="enterprise-tool-card__noise" aria-hidden="true" />
            <div className="flex items-start gap-3">
              <ToolLogo domain={domain} alt={`${tool.name || 'Tool'} logo`} />
              <div>
                <h3 className="text-base font-semibold" style={{ color: 'var(--text-primary)' }}>{tool.name || 'AI Tool'}</h3>
                <p className="text-sm leading-relaxed" style={{ color: 'var(--text-secondary)' }}>
                  {tool.description || tool.tagline || 'A practical AI tool to improve team execution and delivery quality.'}
                </p>
              </div>
            </div>

            <div className="mt-auto flex justify-center pt-2">
              <Link
                to={`/tools/${tool.slug}`}
                className="premium-tool-cta inline-flex items-center justify-center min-w-[160px] rounded-full border px-4 py-2 text-sm font-semibold"
              >
                View Tool
              </Link>
            </div>
          </article>
        );
      })}
    </div>
  );
};

export default EnterpriseBentoGrid;
